









































































































































import {
  PaymentRequisitionFilterParams,
  PaymentRequisitionStatus,
  PaymentRequisitionStatusEnum
} from '@/models';
import EmployeeUserPicker from '../employee/EmployeeUserPicker.vue';

import mixins from '@/utils/mixins';
import Auth from '@/mixins/auth';

export default mixins(Auth).extend({
  name: 'PaymentRequisitionSearchFilter',

  components: { EmployeeUserPicker },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as PaymentRequisitionFilterParams
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    },

    stateList() {
      return PaymentRequisitionStatus.getStateList();
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;
      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: PaymentRequisitionFilterParams) {
      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      if (params.po_number) {
        this.filterParams.po_number = params.po_number;
      }

      if (this.isUserPaymentRequisitionAdmin) {
        if (params.owner != null && !isNaN(params.owner)) {
          this.filterParams.owner = Number(params.owner);
        }
      }
      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
